/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";

import { Container, Row, Col } from "react-awesome-styled-grid";
import { Box, Heading, Loader, Message } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { useAxios } from "~/tools";
import { ServiceLevelGlobal } from "./ServiceLevelGlobal";
import { Level } from "./types";

function GlobalSettingsPage() {
  const [isLoading, setIsLoading] = React.useState(true);
  const [serviceLevels, setServiceLevel] = React.useState<Array<Level>>([]);
  const { showError } = useShowError();
  const { Axios } = useAxios();

  const fetchServiceLevels = React.useCallback(async () => {
    try {
      const { data } = await Axios().get(`/servicelevels`);
      setServiceLevel(data.serviceLevels);
    } catch (e) {
      showError(e.response);
    } finally {
      setIsLoading(false);
    }
  }, [Axios, showError]);

  React.useEffect(() => {
    fetchServiceLevels();
  }, [fetchServiceLevels]);

  return (
    <Container>
      <Row>
        <Col>
          <Box
            css={{ display: "flex", alignItems: "center" }}
            spacing="spacing04"
          >
            <Heading level={2}>Global Settings</Heading>
          </Box>
          <Box spacing="spacing04">
            <Heading css={{ marginBottom: "1rem" }} level={4}>
              Global capacity based Pricing Rules
            </Heading>
            {isLoading ? (
              <Loader inContent />
            ) : (
              serviceLevels?.map((level) => (
                <ServiceLevelGlobal key={level.id} level={level} />
              ))
            )}
            {!isLoading && !serviceLevels && (
              <Message css={{ marginBottom: "1rem" }} status="danger">
                No service levels defined
              </Message>
            )}
          </Box>
        </Col>
      </Row>
    </Container>
  );
}

export { GlobalSettingsPage };
